'use client';

import { ErrorBoundary } from '@appsignal/react';
import { PropsWithChildren } from 'react';

import { MarketingScripts } from '@/components/MarketingScripts';
import { LayoutContextProvider } from '@/context/layout-context';
import { ZmyleCookieProvider } from '@/hooks/useZmyleCookieStore';
import { MobileNavigationProvider } from '@/layout/Navigation/Mobile/mobile-navigation-context';
import { AppSignalClient } from '@/services/appSignal';
import { ClientConfig, IClientConfig } from '@/services/clientConfig';
import { isServer } from '@/utils/helpers';

export type ZmyleCookieConfig = {
  zmyleCookie: ZmyleCookie;
  scriptVersion: string;
};

export type ProvidersProps = PropsWithChildren<{
  zmyleCookieConfig: ZmyleCookieConfig;
  layoutContent: AppLayoutContent;
  clientConfig: IClientConfig;
  nonce: string | null;
}>;

export function Providers({
  children,
  zmyleCookieConfig,
  layoutContent,
  clientConfig,
  nonce,
}: ProvidersProps) {
  if (!isServer() && !ClientConfig.isPopulated()) {
    ClientConfig.set(clientConfig);
  }

  const appSignal = AppSignalClient.getInstance().getClient();

  return (
    <ErrorBoundary instance={appSignal}>
      <ZmyleCookieProvider zmyleCookie={zmyleCookieConfig.zmyleCookie}>
        <MarketingScripts nonce={nonce} />

        <LayoutContextProvider content={layoutContent}>
          <MobileNavigationProvider>{children}</MobileNavigationProvider>
        </LayoutContextProvider>
      </ZmyleCookieProvider>
    </ErrorBoundary>
  );
}
